import React from 'react';
import cn from 'classnames';
import { reduxForm, Field } from 'redux-form';

import FormError from 'components/FormError';
import InputField from 'components/InputField';
import SelectField from 'components/SelectField';
import expiryTypes from 'constants/expiryTypes';
import { isBlank } from 'helpers/validators';

import styles from './styles.module.scss';

let MassExpireForm = ({
  handleSubmit,
  error,
  carrier,
  simoExpiryTypeOptions,
}) => {
  const isAtt = carrier === 'att';
  const isSimo = carrier === 'simo';
  const isQuick = carrier === 'quick';
  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={cn(styles.inputs, { [styles.withCheckbox]: isAtt })}>
        {isAtt && (
          <Field
            component={InputField}
            name="subscription_ids"
            label="Subscription IDs*"
            subText="Comma separated list. Ex.: 101,201"
          />
        )}
        {isSimo && (
          <Field
            component={InputField}
            name="device_sns"
            label="Device SNs*"
            subText="Comma separated list. Ex.: abc0000d0efgh00i,abc0000d0efgh01i"
          />
        )}
        {isQuick && (
          <Field
            component={InputField}
            name="sub_ids"
            label="Subscription IDs*"
            subText="Comma separated list. Ex.: 101,201"
          />
        )}
        <Field
          component={SelectField}
          name="expiry_type"
          label="Expiry Type*"
          empty="Choose a expiry type"
          options={isSimo ? simoExpiryTypeOptions : expiryTypes}
        />
      </div>
      <br />
      {error && <FormError error={error} />}
      <button className="btn btn-primary">Mass Expire</button>
    </form>
  );
};

const validate = (values, { carrier }) => {
  let errors = {};

  let requiredFields;
  if (carrier === 'att') {
    requiredFields = ['subscription_ids', 'expiry_type'];
  } else if (carrier === 'simo') {
    requiredFields = ['device_sns', 'expiry_type'];
  } else if (carrier === 'quick') {
    requiredFields = ['sub_ids', 'expiry_type'];
  }
  requiredFields.forEach((field) => {
    if (isBlank(values[field])) {
      errors[field] = 'Required';
    }
  });

  return errors;
};

MassExpireForm = reduxForm({
  form: 'massExpireForm',
  validate,
})(MassExpireForm);

export default MassExpireForm;
